import { render, staticRenderFns } from "./EducationalItemSummary.vue?vue&type=template&id=8a338b74&scoped=true&"
import script from "./EducationalItemSummary.vue?vue&type=script&lang=js&"
export * from "./EducationalItemSummary.vue?vue&type=script&lang=js&"
import style0 from "./EducationalItemSummary.vue?vue&type=style&index=0&id=8a338b74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a338b74",
  null
  
)

export default component.exports